<template>
  <div class="flex flex-col py-16">
    <h3 class="heading-xxs">Din e-post</h3>
    <p class="text-wrap max-w-546">
      Fyll i din e-postadress som du vill använda för orderbekräftelse och annan
      kommunikation. Uppdatera din e-post om den inte stämmer.
    </p>
    <div class="py-16 max-w-546">
      <InputText
        :name="STEP3_ADDRESS_PERSONAL_EMAIL"
        :input-id="STEP3_ADDRESS_PERSONAL_EMAIL"
        type="text"
        :initial-value="checkoutStore.userState.newEmailAddress"
        label="Fyll i din e-post"
        help-text="Rätt format: example@halebop.se"
        :validate="[
          'emailNotEmpty',
          'emailCorrectFormat',
          'emailAddressContainsNoSwedishCharacters',
        ]"
        placeholder="example@halebop.se"
        mode="eager"
      />
    </div>

    <div aria-live="polite" aria-atomic="true">
      <div v-if="checkoutStore.customerConsents.length > 0">
        <h2
          class="heading-xs py-16 border-t-md border-solid border-border-secondary"
        >
          Service och säkerhet
        </h2>
        <p class="mb-3 max-w-546">
          Den 25e maj 2018 infördes en ny jättebra reglering för dataskydd
          (GDPR), vi behöver därför be om ditt förtroende att hantera din data.
          Du kan läsa mer
          <NuxtLink
            external
            target="_blank"
            href="https://www.halebop.se/samtycke"
            no-prefetch
          >
            här
          </NuxtLink>
        </p>
        <div
          v-for="consent in checkoutStore.customerConsents"
          :key="consent.Purpose"
          class="max-w-546"
        >
          <InputCheckbox
            v-model="consent.Checked"
            :label="consent.Description"
          />
        </div>
      </div>
      <div v-else-if="checkoutStore.ui.loading.isStep3AddressLoading">
        <div
          class="py-16 w-full border-t-md border-solid border-border-secondary motion-safe:animate-pulse motion-reduce:animate-none"
          aria-hidden="true"
        >
          <span class="w-[250px] h-24 bg-text-disabled block" />
        </div>
        <div
          class="mb-10 w-full max-w-546 motion-safe:animate-pulse motion-reduce:animate-none"
          aria-hidden="true"
        >
          <span class="w-full h-16 md:20 mt-2 bg-text-disabled block" />
          <span class="w-full h-16 md:20 mt-2 bg-text-disabled block" />
          <span class="w-[160px] h-16 md:20 mt-2 bg-text-disabled block" />
        </div>
        <div class="max-w-546">
          <CheckoutLoadingGuiCustomerConsents
            text-for-screen-readers="Laddar godkännanden, vänligen vänta."
          />
          <CheckoutLoadingGuiCustomerConsents class="mt-26 pb-10" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { STEP3_ADDRESS_PERSONAL_EMAIL } from '~/models/checkout/forms/Step3Form.model';
const checkoutStore = useMyCheckoutStore();
</script>
